import { CustomTooltipComponent } from '@r1-development/rps-shared-ui';
import { ColDef } from 'ag-grid-community';

/**
 * tooltipField: 'skip' this is to avoid default tooltip by AG-Grid
 * and use the custme tooltip component for fast rendering of the tooltip
 */
export const DefaultColDef: ColDef = {
  tooltipComponent: CustomTooltipComponent,
  tooltipValueGetter: () => {
    return '';
  },
};
